import React from 'react';
import { getTopRecommendations } from '../../../utils/assessmentResults/calculations';
import { RecommendationCard } from '../Components/RecommendationCard';
import { CategoryStats } from '../Components/CategoryStats';

/**
 * Priority Opportunities Tab Component
 */
export const PriorityOpportunitiesTab = ({ recommendations = [] }) => {
  const safeRecommendations = recommendations || [];
  const topRecommendations = getTopRecommendations(safeRecommendations, 6);

  if (safeRecommendations.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Priority Opportunities</h3>
        <p className="text-gray-600 dark:text-gray-400">
          No recommendations available yet. Recommendations will appear here once the assessment analysis is complete.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Top Priority Opportunities</h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Based on your assessment responses, here are your highest-impact energy saving opportunities:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {topRecommendations.map((rec, index) => (
            <RecommendationCard key={index} recommendation={rec} index={index} />
          ))}
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Implementation Categories</h3>
        <CategoryStats recommendations={safeRecommendations} />
      </div>
    </div>
  );
};

